import { Box, Theme, makeStyles } from '@material-ui/core';
import { IconComponent } from '@backstage/core-plugin-api';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    lineHeight: 0,
  },
}));

export const IconText = (props: { Icon: IconComponent; text: string }) => {
  const classes = useStyles();
  const { Icon, text } = props;
  return (
    <Box component="span" className={classes.root}>
      <Box component="span" className={classes.icon}>
        <Icon fontSize="inherit" />
      </Box>
      {text}
    </Box>
  );
};
